var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScheduleAppointment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12815",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12816",
    d: "M15 3v2",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12817",
    d: "M7 3v2",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12818",
    d: "M3 8h16",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12819",
    d: "M19 10V6a2 2 0 00-2-2H5a2 2 0 00-2 2v11a2 2 0 002 2h6",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12820",
    d: "M7 10.75a.25.25 0 10.25.25.249.249 0 00-.25-.25",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12821",
    d: "M7 14.75a.25.25 0 10.25.25.249.249 0 00-.25-.25",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12822",
    d: "M10.75 11a.25.25 0 10.25-.25.249.249 0 00-.25.251",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12827",
    d: "M18.655 17.476c-1.538 1.539-3.488 2.52-4.647 1.366l-.281-.281a.847.847 0 01.113-1.3c.274-.191.569-.4.894-.625a.855.855 0 011.091.09l.318.316a6.814 6.814 0 001.146-.932h0a6.786 6.786 0 00.932-1.146l-.316-.318a.855.855 0 01-.09-1.091c.23-.326.435-.62.625-.894a.848.848 0 011.3-.113l.281.281c1.154 1.159.173 3.107-1.365 4.647",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
export default SvgScheduleAppointment;


//////////////////
// WEBPACK FOOTER
// ./src/icons/scheduleAppointment.svg
// module id = 786
// module chunks = 13